import {
  CommonGenerationTileProps,
  GenerationTileAction,
} from "@/components/Tiles/GenerationTile/types";
import {
  TileBase,
  TileLikeButton,
  TileObjectTypeIndicator,
} from "@/components/ui-v2";
import { SessionAssetFragment } from "@/features/forge/forge-session/queries.graphql";

import { AssetGenerationTileButtons } from "./AssetGenerationTileButtons";

export const AssetGenerationTile = (
  props: CommonGenerationTileProps<SessionAssetFragment>,
) => {
  const {
    object,
    isSelected = false,
    isSelectable = false,
    isLiking = false,
    onAction,
    ...rest
  } = props;

  const { previewUrl, isLiked } = object;

  const handleTileBaseAction =
    (action: GenerationTileAction) => (e: React.MouseEvent) => {
      onAction?.(e, action);
    };

  return (
    <TileBase
      isSelected={isSelected}
      isSelectable={isSelectable}
      slots={{
        bottomLeftEl: AssetGenerationTileButtons,
        topLeftEl: TileObjectTypeIndicator,
        bottomRightEl: TileLikeButton,
      }}
      slotProps={{
        bottomLeftEl: {
          onAction,
        },
        topLeftEl: {
          isSelected,
          objectType: "canvas",
        },
        bottomRightEl: {
          isLiked,
          isLoading: isLiking,
          onAction,
          sx: {
            m: 1,
          },
        },
      }}
      onClick={handleTileBaseAction("SELECT")}
      onDoubleClick={handleTileBaseAction("DOUBLE_CLICK")}
      onContextMenu={handleTileBaseAction("OPEN_CONTEXT_MENU")}
      {...rest}
    >
      {previewUrl && <img src={previewUrl} loading="lazy" alt={object.name} />}
    </TileBase>
  );
};
